import querystring from "querystring";
import { ApiRest } from "react-comun-seps/lib/api/ApiRest";
import { datosLocalesHelper } from "react-comun-seps/lib/helpers/datosLocalesHelper";
import { API_ROOT } from "node-constantes-seps";

export const userService = {
  login,
  sistemas,
  subsistemas,
  organizaciones,
  logout,
  validacion,
  actualizaClave,
  validaTicket,
  acuerdos,
  verAcuerdo,
  banner,
  guardarConcentimiento,
  descargarAcuerdo,
  crearSistema,
};

//const apiUrl = 'https://172.30.1.72:8443';

const apiUrlAcuerdo =
  window.location.hostname === "sca.seps.local"
    ? "http://sca.seps.local"
    : window.location.hostname === "localhost"
    ? "http://localhost:5068"
    : window.location.hostname === "sistemas.seps.gob.ec"
    ? "https://sistemas.seps.gob.ec"
    : "";

var apiUrl = API_ROOT;

function login(username, password) {
  var params = {
    usuario: username,
    contrasenia: password,
    sessionId: ApiRest.obtenerDatoLocal("sessionId"),
  };

  return ApiRest.post(`${apiUrl}/sca/acceso/autenticacion/login`, querystring.stringify(params), {
    "Content-Type": "application/x-www-form-urlencoded",
  }).then((data) => {
    if (data.identificadorSesion) {
      let nombreCompleto = data.nomNombre;
      let nombre = data.nomApellido ? data.nomApellido : "";
      ApiRest.guardarDatoLocal("tokenSeps", JSON.stringify(data.identificadorSesion));
      ApiRest.guardarDatoLocal("usuarioCI", data.codIdentificacion);
      ApiRest.guardarDatoLocal("usuarioCorreo", data.txtCorreoElect);
      ApiRest.guardarDatoLocal("usuarioNombre", nombreCompleto + " " + nombre);
      var decoded = datosLocalesHelper();
      return decoded.tokenSeps;
    }
  });
}

function validacion(usuario, correoelectronico) {
  var params = {
    usuario: usuario,
    "correo-electronico": correoelectronico,
  };

  return ApiRest.post(
    `${apiUrl}/sca/acceso/usuarios/validar-usuario-con-correo-electronico`,
    querystring.stringify(params),
    { "Content-Type": "application/x-www-form-urlencoded" }
  ).then((respuesta) => {
    return respuesta;
  });
}

function validaTicket(ticket) {
  return ApiRest.get(`${apiUrl}/sca/acceso/usuarios/validar-ticket?ticket=${ticket}`).then(
    (respuesta) => {
      return respuesta;
    }
  );
}

function actualizaClave(usuario, contrasenia, ticket) {
  var params = {
    usuario: usuario,
    contrasenia: contrasenia,
    ticket: ticket,
  };
  return ApiRest.post(
    `${apiUrl}/sca/acceso/usuarios/cambio-contrasenia`,
    querystring.stringify(params),
    { "Content-Type": "application/x-www-form-urlencoded" }
  ).then((respuesta) => {
    return respuesta;
  });
}

function banner() {
  return ApiRest.get(`${apiUrlAcuerdo}/ms-acuerdo-responsabilidad/common/getBannerImage`).then(
    (bannerImg) => {
      return bannerImg;
    }
  );
}

function acuerdos(user) {
  try {
    return ApiRest.post(
      `${apiUrlAcuerdo}/ms-acuerdo-responsabilidad/acuerdoResponsabilidad/listarAcuerdosUsuario`,
      user,
      { "Content-Type": "application/json" }
    ).then(
      (listaAcuerdos) => {
        return listaAcuerdos;
      },
      (error) => {
        console.log("In the error: ", error);
        return null;
      }
    );
  } catch (e) {
    console.log("In the exception: ", e);
  }
}

function verAcuerdo(idACuerdo) {
  return ApiRest.post(
    `${apiUrlAcuerdo}/ms-acuerdo-responsabilidad/acuerdoResponsabilidad/encontrarPlantillaAcuerdo`,
    idACuerdo,
    { "Content-Type": "application/json" }
  ).then((textoAcuerdo) => {
    return textoAcuerdo;
  });
}

function descargarAcuerdo(datosUsuario) {
  return ApiRest.post(
    `${apiUrlAcuerdo}/ms-acuerdo-responsabilidad/acuerdoResponsabilidad/enviarPlantillaAcuerdo`,
    datosUsuario,
    { "Content-Type": "application/json" }
  ).then((acuerdo) => {
    return acuerdo;
  });
}

function guardarConcentimiento(datos) {
  return ApiRest.post(
    `${apiUrlAcuerdo}/ms-acuerdo-responsabilidad/acuerdoResponsabilidad/crearRegistroAcuerdoUsuExt`,
    datos,
    { "Content-Type": "application/json" }
  ).then((respuestaConcentimiento) => {
    return respuestaConcentimiento;
  });
}

function sistemas(user) {
  return ApiRest.get(`${apiUrl}/sca/acceso/sistemas/usuario/${user}`).then((listasistemas) => {
    return listasistemas;
  });
}

function subsistemas(sistema, user) {
  return ApiRest.get(
    `${apiUrl}/sca/acceso/subsistemas/usuario/${user.idusuario}/sistema/${sistema.codSistema}`
  ).then((listasubsistemas) => {
    return listasubsistemas;
  });
}

function organizaciones(user, sistema) {
  return ApiRest.get(
    `${apiUrl}/sca/acceso/orgs-roles-usuarios/usuario/${user.idusuario}/subsistema/${sistema.codSistema}`
  ).then((listaorganizaciones) => {
    return listaorganizaciones;
  });
}

function cerrarSesion(data) {
  return ApiRest.post(`${apiUrl}/sca/acceso/autenticacion/cerrar-sesion`, data).then((response) => {
    return response;
  });
}

 function crearSistema(data) {
  return ApiRest.post(`${apiUrl}/sca/acceso/autenticacion/crear-sistema`, data).then((response) => {
    return response;
  });
}

function logout() {
  // remove user from local storage to log user out
  let userDecode = datosLocalesHelper();
  let data = {
    usuario: userDecode ? userDecode.tokenSeps.sub : null,
    sessionId: ApiRest.obtenerDatoLocal("sessionId"),
  };
  userDecode && cerrarSesion(data);
  ApiRest.clearDatoLocal();
}
